module.exports = __webpack_public_path__ + "static/img/picture.5ad7f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture.png
// module id = pK10
// module chunks = 3